module.exports = __webpack_public_path__ + "img/40_000_004.6e594fa6.jpg";